import angular from 'angular';
import angularRoute from 'angular-route';
import * as Sentry from '@sentry/browser';
import { Angular as AngularIntegration } from '@sentry/integrations';

import browserConfig from '../../config/browser.config';

import root from './modules/root';
import common from './modules/common';
import auth from './modules/auth';
import legacy from './modules/legacy';

/**
 * Define the configuration object by merging the imported configuration and one the server injects
 * on the HTML template.
 * This will be registered as the `appConfiguration` constant.
 * @type {ngConstant}
 * @memberof ssoApp
 */
const appConfiguration = Object.assign(
  {},
  browserConfig,
  (global.appConfiguration || {}),
);
/**
 * This will contain the list of modules that depends on features sent by the server.
 * @type {Array}
 */
const featuresModules = [];
// Add Sentry if enabled...
const { features: { sentry } } = appConfiguration;
if (sentry.enabled) {
  Sentry.init({
    dsn: `https://${sentry.apiKey}@sentry.io/${sentry.projectId}`,
    integrations: [
      new AngularIntegration(),
    ],
  });

  featuresModules.push('ngSentry');
}
/**
 * @ngdoc module
 * @name ssoApp
 * @description
  * The app main module. It doesn't have any component nor services, it only takes care of
  * including the rest of the modules and defining the `appConfiguration` constant.
 */
angular
.module('ssoApp', [
  ...featuresModules,
  angularRoute,
  root,
  common,
  auth,
  legacy,
])
.constant('appConfiguration', appConfiguration);
